import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const PDPCompleteOrderPlaceholder = () => (
  <div className="flex flex-col w-full min-h-[200px] mt-8">
    <Placeholder type="rect" loading className="!w-full !h-[56px]" />
    <div className="flex flex-row items-start my-6">
      <Placeholder
        type="rect"
        loading
        className="!w-[18px] !h-[18px] rounded-sm"
      />
      <Placeholder type="text" rows={2} loading className="!w-full !h-[47px]" />
    </div>
    <Placeholder type="rect" loading className="!w-full !h-[52px]" />
  </div>
);

export default PDPCompleteOrderPlaceholder;
